import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';

export const useTrackBestPriceHint = (label: string) => {
  const trackFeature = useTrackFeature();
  const {ref} = useTrackFeatureInViewImpression<HTMLSpanElement>({
    label,
  });

  const trackInfoClick = () => {
    trackFeature({
      eventType: 'click',
      label,
    });
  };

  const trackLearnMoreClick = () => {
    trackFeature({
      eventType: 'submit',
      label,
    });
  };

  return {
    trackInfoClick,
    trackLearnMoreClick,
    infoIconRef: ref,
  };
};
